/* Casify — scroll reveal
   Progressive enhancement: adds .reveal-init to <html> only when
   IntersectionObserver exists and the user hasn't asked for reduced
   motion. base.css hides [data-reveal] elements only under .reveal-init,
   so without JS (or with reduced motion) everything stays visible. */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var els = document.querySelectorAll('[data-reveal]');
  if (!els.length) return;

  // reveal-no-anim suppresses transitions for one frame so below-fold
  // elements snap to their hidden state instead of visibly fading out.
  document.documentElement.classList.add('reveal-no-anim', 'reveal-init');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  els.forEach(function (el) {
    // Elements already in view on load reveal immediately (no pop-in on refresh mid-page)
    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      el.classList.add('is-revealed');
    } else {
      observer.observe(el);
    }
  });

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      document.documentElement.classList.remove('reveal-no-anim');
    });
  });
})();
